import { useRole, ROLES, UserRole } from "@/data/RoleContext";
import {
  ShieldCheck,
  Crown,
  Settings2,
  Clipboard,
  HardHat,
  Truck,
  TrendingUp,
  Warehouse,
  Check,
  CircleDollarSign,
  Calculator,
  BookOpen,
  ShoppingCart,
  Monitor,
} from "lucide-react";

const roleIcons: Record<UserRole, React.ElementType> = {
  super_admin: ShieldCheck,
  owner: Crown,
  ops_manager: Settings2,
  admin: Clipboard,
  warehouse_manager: Warehouse,
  installer: HardHat,
  subcontractor: Truck,
  sales: TrendingUp,
  sales_manager: TrendingUp,
  call_center: Clipboard,
  cfo: CircleDollarSign,
  finance_manager: Calculator,
  bookkeeper: BookOpen,
  head_of_installation: HardHat,
  procurement_manager: ShoppingCart,
  inventory_manager: Warehouse,
  it_staff: Monitor,
};

const SWITCHER_ALLOWED_ROLES: UserRole[] = ["super_admin", "owner", "admin", "it_staff"];

export function RoleSwitcher() {
  const { role, accountRole, setRole } = useRole();

  const canSwitch = SWITCHER_ALLOWED_ROLES.includes(accountRole);
  const visibleRoles = canSwitch ? ROLES : ROLES.filter((r) => r.key === accountRole);

  return (
    <div className="space-y-0.5">
      {visibleRoles.map((r) => {
        const Icon = roleIcons[r.key];
        const active = role === r.key;
        return (
          <button
            key={r.key}
            onClick={() => canSwitch && setRole(r.key)}
            className={`w-full flex items-center gap-2.5 px-2.5 py-[7px] rounded-md text-[12px] font-medium transition-all text-left ${
              active
                ? "bg-sidebar-accent text-sidebar-accent-foreground"
                : canSwitch
                  ? "text-sidebar-foreground/45 hover:bg-sidebar-accent/50 hover:text-sidebar-foreground/70"
                  : "text-sidebar-foreground/45 cursor-default"
            }`}
          >
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span className="flex-1">{r.label}</span>
            {active && <Check className="h-3 w-3 shrink-0" />}
          </button>
        );
      })}
    </div>
  );
}
